import React from "react";
import StatusBadge, {
  StatusBadgeColorVariant,
} from "@/shared/components/StatusBadge";
import { OrderSheetStatus } from "@/features/order-sheets/order-sheet.type";
import { convertOrderStatusToNew } from "@/shared/utils";
import { orderStatusOptionList } from "@/shared/constants/status";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import {
  CombinedRemittanceStatus,
  DifferenceRemittanceStatus,
  RemittanceStatus,
} from "@/features/invoices/invoice.type";

interface Props {
  status: CombinedRemittanceStatus;
}

const remittanceStatusColorVariantMap: Record<
  CombinedRemittanceStatus,
  StatusBadgeColorVariant
> = {
  REMITTANCE_REQUIRED: "red",
  REMITTED: "green",
  RETURNED: "green",
  RETURN_REQUIRED: "blue",
};

function RemittanceStatusBadge({ status }: Props) {
  const { tTitle } = useI18nHelper();

  return (
    <StatusBadge
      status={tTitle("remittance_status." + status.toLowerCase())}
      colorVariant={remittanceStatusColorVariantMap[status]}
      size={"medium"}
    />
  );
}

export default RemittanceStatusBadge;
